import React, { useEffect, useState } from "react";
import { mdiAutoFix, mdiBatteryCharging, mdiPauseCircleOutline, mdiRobotVacuum, mdiRotateRight, mdiWall } from "@mdi/js";
import MdiIcon from "../../../components/device/app/MdiIcon";
import { TRAITS, hasTrait } from "../../../constants/devices";
import { sendControl } from "../../../services/deviceControl";
import { useToggleTop } from "../../../components/common/ToggleTop";
import { VACUUM_STATUS } from "./UsageHistory";

// Work modes the app offers (trait 1103).
const MODES = [
  { value: 1, title: "Smart", icon: mdiAutoFix },
  { value: 2, title: "Wall Follow", icon: mdiWall },
  { value: 3, title: "Spiral", icon: mdiRotateRight },
  { value: 0, title: "Standby", icon: mdiPauseCircleOutline },
  { value: 4, title: "Charge", icon: mdiBatteryCharging },
];

// Which mode button a reported work status belongs to.
const modeForStatus = (status) => {
  const s = Number(status);
  if ([1, 2, 3].includes(s)) return s;
  if ([5, 6, 7, 10, 11].includes(s)) return 4;
  return 0;
};

// Robot vacuum (WGRVC_1/2): cleaning stats, status and work modes.
const VacuumControl = ({ device, lastState, onChanged }) => {
  const toast = useToggleTop();
  const state = Object.values(lastState?.devices ?? {})[0] ?? {};
  const [mode, setMode] = useState(modeForStatus(state.work_stat));

  useEffect(() => setMode(modeForStatus(state.work_stat)), [state.work_stat]);

  const choose = async (value) => {
    const previous = mode;
    setMode(value);
    try {
      await sendControl({
        on: [`${device.applianceId}`],
        off: [],
        action: { [device.applianceId]: { id: 1, trait: Number(TRAITS.VACUUM_MODE), value } },
      });
      onChanged?.();
    } catch (err) {
      setMode(previous);
      toast("Couldn't reach the vacuum. Please try again.", "red");
    }
  };

  return (
    <>
      <div className="hx-vac-stats">
        <div>
          <strong>{state.clean_area ?? 0} m.sq</strong>
          <span>Cleaning Area</span>
        </div>
        <div>
          <strong>{state.clean_time ?? 0} min</strong>
          <span>Cleaning Time</span>
        </div>
        <div>
          <strong>{state.bts ?? 0} %</strong>
          <span>Battery Level</span>
        </div>
      </div>
      <div className="hx-vac-image" aria-hidden="true">
        <MdiIcon path={mdiRobotVacuum} size={170} />
      </div>
      <p className="hx-vac-status" role="status">
        {VACUUM_STATUS[state.work_stat] ?? "Standby"}
      </p>
      {hasTrait(device, TRAITS.VACUUM_MODE) ? (
        <div className="hx-vac-modes" role="group" aria-label="Cleaning mode">
          {MODES.map((item) => (
            <button
              key={item.value}
              type="button"
              className={`hx-vac-mode ${mode === item.value ? "is-selected" : ""}`}
              aria-pressed={mode === item.value}
              onClick={() => choose(item.value)}
            >
              <span aria-hidden="true">
                <MdiIcon path={item.icon} size={26} />
              </span>
              <span>{item.title}</span>
            </button>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default VacuumControl;
